import { useContext, useEffect, useState } from 'react';

import { FetchHookState } from './types/FetchHookState';
import { environmentContext } from '../../../environmentContext/environmentContext';
import { MatchingReportForAccount } from '../../../types/MatchingReportForAccount';

export type UseFetchMatchingReportForAccountState = FetchHookState<MatchingReportForAccount[]>;

const defaultState: UseFetchMatchingReportForAccountState = {
  data: [],
  loading: true,
};
export const useFetchMatchingReports = (integrationType?: string) => {
  const [fetchHookState, setFetchHookState] = useState<UseFetchMatchingReportForAccountState>(defaultState);
  const services = useContext(environmentContext);
  useEffect(() => {
    if (!integrationType) return;
    setFetchHookState(defaultState);
    services.MatchingApiClient.fetchMatchingReport(integrationType)
      .then((data) => {
        setFetchHookState({
          data,
          loading: false,
        });
      })
      .catch((error) => {
        setFetchHookState({
          data: [],
          error,
          loading: false,
        });
      });
  }, [services, integrationType]);
  return fetchHookState;
};
